import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import $ from 'jquery';
import { ChiamaAPI, Trad, Tipo, CampoData, BottoneAPI, CampoNumero, CampoStringa, InputTesto, Bottone } from '../components/';
import ChiamaWeb, { CChiamaWebParametri, TParamURLLista } from '../ChiamaWeb';
import { useRoC } from '../hooks/ReducerOnChange';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

export const EstrattoContoDettagli: React.FC<Glob.IRouteGlobaleProps> = (props) => {
    const [Caricamento, setCaricamento] = React.useState(false);
    const [ID_EstrattoConto,] = React.useState((props.match.params as any).ID_EstrattoConto as number);
    const [Data, setData] = React.useState<Dati.CRisAPIListaEstrattoContoDettagli>();
    const [EstrattoConto, setEstrattoConto] = useRoC(new Dati.CDatiEstrattoConto());

    function TotalePremioLordoDare(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            R += Q.PremioLordoDare ?? 0;
        });
        return R;
    }

    function TotaleProvvigioniDare(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            R += Q.ProvvigioniDare ?? 0;
        });
        return R;
    }

    function TotalePremioLordoAvere(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            R += Q.PremioLordoAvere ?? 0;
        });
        return R;
    }

    function TotaleProvvigioniAvere(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            R += Q.ProvvigioniAvere ?? 0;
        });
        return R;
    }

    //TODO Non gestisce pi� di una voce
    function TotaleDescrExtra(): string | undefined {
        let R: string | undefined;
        Data?.RisAPI.Dati.map(Q => {
            R = Q.Extra.length === 0 ? undefined : Q.Extra[0].Nome;
        });
        return R === null ? undefined : R;
    }

    //TODO Non gestisce pi� di una voce
    function TotalePercRitenuta(): number | undefined {
        let R: number | undefined;
        Data?.RisAPI.Dati.map(Q => {
            R = Q.PercRitenuta;
        });
        return R === null ? undefined : R;
    }

    function TotaleRitenuta(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            R += Q.Ritenuta ?? 0;
        });
        return R;
    }

    function TotalePremioLordoIncassi(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            R += Q.ID_TipoQuietanzaStato === Glob.Tipi_QS_Incassata ? Q.PremioLordoAvere + Q.PremioLordoAvere : 0;
        });
        return R;
    }

    function TotaleExtra(): number {
        let R = 0;
        Data?.RisAPI.Dati.map(Q => {
            Q.Extra.map(E => R += E.Importo);
        });
        return R;
    }

    function TotaleIncassi(): number {
        return TotalePremioLordoIncassi() + TotaleExtra();
    }

    function TotaleSaldo(): number {
        return (TotalePremioLordoDare() + TotalePremioLordoAvere())
            - TotalePremioLordoIncassi()
            - (TotaleProvvigioniDare() + TotaleProvvigioniAvere())
            + TotaleRitenuta()
            + TotaleExtra();
    }

    const memoTotaleDescrExtra = React.useMemo(() => TotaleDescrExtra(), [Data?.RisAPI]);
    const memoTotaleExtra = React.useMemo(() => TotaleExtra(), [Data?.RisAPI]);
    const memoTotaleIncassi = React.useMemo(() => TotaleIncassi(), [Data?.RisAPI]);
    const memoTotalePercRitenuta = React.useMemo(() => TotalePercRitenuta(), [Data?.RisAPI]);
    const memoTotalePremioLordoAvere = React.useMemo(() => TotalePremioLordoAvere(), [Data?.RisAPI]);
    const memoTotalePremioLordoDare = React.useMemo(() => TotalePremioLordoDare(), [Data?.RisAPI]);
    const memoTotalePremioLordoIncassi = React.useMemo(() => TotalePremioLordoIncassi(), [Data?.RisAPI]);
    const memoTotaleProvvigioniAvere = React.useMemo(() => TotaleProvvigioniAvere(), [Data?.RisAPI]);
    const memoTotaleProvvigioniDare = React.useMemo(() => TotaleProvvigioniDare(), [Data?.RisAPI]);
    const memoTotaleRitenuta = React.useMemo(() => TotaleRitenuta(), [Data?.RisAPI]);
    const memoTotaleSaldo = React.useMemo(() => TotaleSaldo(), [Data?.RisAPI]);

    function CaricaListaDettagli() {
        setCaricamento(true);
        const ParamURL: TParamURLLista = {};
        ParamURL["ID_EstrattoConto"] = ID_EstrattoConto;

        const Param: CChiamaWebParametri = {
            URL: "/api/EstrattoConto/Dettagli",
            Metodo: "POST",
            ParamURLLista: ParamURL,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPIListaEstrattoContoDettagli) => {
                setCaricamento(false);
                if (dati.RisAPI.Errore) {
                    setData(undefined);
                    setEstrattoConto({ Type: "Set", Value: new Dati.CDatiEstrattoConto() });
                } else {
                    setData(dati);
                    setEstrattoConto({ Type: "Set", Value: dati.Extra });
                }
            },
            OnErrore: (sender: ChiamaWeb, errore: Error) => {
                setCaricamento(false);
                setData(undefined);
                setEstrattoConto({ Type: "Set", Value: new Dati.CDatiEstrattoConto() });
            }
        };
        ChiamaWeb.ChiamaWeb(Param);
    }

    let Tabella: any = null;
    const refTabella = React.useRef(null);

    function AttivaTabella() {
        if (Dati !== undefined) {
            const T = $((refTabella.current) as any);

            Tabella = T.DataTable({
                responsive: true,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                destroy: true
            });
        }
    }

    React.useEffect(() => {
        if (!Glob.AzioneAbilitata("EstrattoContoController", Glob.Lettura)) {
            props.history.push("/EstrattoConto");
        }
        AttivaTabella();
        CaricaListaDettagli();
    }, []);

    function OnClickBottoneAPI(s: BottoneAPI, dati: Dati.CRisAPI): void {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("EstrattoContoErrore"), Trad.Trad(dati.ErrTesto));
        } else {
            Glob.InfoModaleSuccess(Trad.Trad("EstrattoConto"), Trad.Trad("EstrattoContoChiuso"), () => props.history.push("/EstrattoConto"));
        }
    }

    function OnClickEliminaDettaglio(s: BottoneAPI, dati: Dati.CRisAPI): void {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("EstrattoContoErrore"), Trad.Trad(dati.ErrTesto));
        } else {
            if (Data) {
                setData({ ...Data, RisAPI: { ...Data.RisAPI, Dati: Data?.RisAPI.Dati.filter(ECD => ECD.ID_EstrattoContoDettaglio !== dati.ID_Chiave) ?? [] } });
            }
        }
    }

    function OnErroreBottoneAPI(s: BottoneAPI, e: Error): void {
        Glob.InfoModaleError(Trad.Trad("EstrattoContoErrore"), e.message);
    }

    function StampaExtra(extra?: Dati.CDatiQuietanzeEstrattoImportiExtra[]): string {
        let R = "";

        for (const E in extra) {
            R += extra[E].Nome + " " + Trad.TradParam("{1-I}", [extra[E].Importo]);
        }

        return R;
    }

    function RiempiTabella(): React.ReactNode {
        if (Tabella) {
            Tabella.destroy();
        }

        if (Caricamento) {
            return <tbody><tr><td colSpan={12}>{Trad.Trad("Caricamento")}</td></tr></tbody>;
        }

        if (Data === undefined || Data.RisAPI.Dati.length === 0) {
            return <tbody><tr>
                <td colSpan={12} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {Data.RisAPI.Dati.map((dato, index) =>
                    <tr key={dato.ID_EstrattoContoDettaglio}>
                        <td className="TextLeft">{Trad.TradParam("DataEmissione{1-D}", [dato.DataEmissione])}<br />{Trad.TradParam("DataRichiestoPagamento{1-D}", [dato.DataRichiestoPagamento])}<br />{Trad.TradParam("DataPagamento{1-D}", [dato.DataPagamento])}<br /></td>
                        <td className="TextCenter">{dato.ID_Quietanza}</td>
                        <td className="TextCenter">{Trad.Trad(Data?.RisAPI.Tipi["QuietanzaStato"][dato.ID_TipoQuietanzaStato].Valore ?? "")}</td>
                        <td className="TextLeft">{dato.Polizza}<br />{dato.AnagContraente}</td>
                        <td className="TextLeft">{dato.Compagnia}<br />{dato.TipoRamo}<br />{dato.TipoProdotto}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.PremioLordoDare])}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.ProvvigioniDare])}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.PremioLordoAvere])}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.ProvvigioniAvere])}</td>
                        <td className="TextRight">{StampaExtra(dato.Extra)}</td>
                        <td className="TextCenter">
                            <BottoneAPI
                                Attivo={EstrattoConto.ID_TipoEstrattoContoStato === Glob.Tipi_ECS_Aperto}
                                Conferma={Trad.Trad("ConfermaElimina")}
                                Default={false}
                                Testo={Trad.Trad("Elimina")}
                                URL="/api/EstrattoConto/EliminaDettaglio"
                                ParamCorpo={{ Dato: dato.ID_EstrattoContoDettaglio } as Dati.CIngrAPI<number>}
                                Metodo="POST"
                                OnClick={(s, d) => OnClickEliminaDettaglio(s, d)}
                                OnErrore={(s, e) => OnErroreBottoneAPI(s, e)}
                                DataDismiss="modal"
                            />
                        </td>
                    </tr>
                )}
            </tbody>;
        }
    }

    function ChiudiEstrattoContoAttivo(): boolean {
        if ((EstrattoConto.PagamentoData?.getFullYear() ?? 0) < 2018) return false;
        if ((EstrattoConto.PagamentoData ?? 0) > new Date()) return false;
        if ((EstrattoConto.PagamentoImporto ?? 0) === 0) return false;
        if (EstrattoConto.ID_TipoEstrattoContoStato === Glob.Tipi_ECS_Chiuso) return false;

        return true;
    }

    function Stampa() {
        let URL = Glob.StampaURL();

        URL += "?SessioneMyAr=" + Glob.GetSessione().Sessione;
        URL += "&Chiave=" + EstrattoConto.ID_EstrattoConto;
        URL += "&Database=" + Glob.StampaDatabaseEstrattoConto();
        URL += "&Data=" + Date.now();
        URL += "&NomeFile=" + "EstrattoConto_" + EstrattoConto.ID_EstrattoConto;
        URL += "&JSON=true";
        URL += "&File=true";
        URL += "&Tipo=";

        const Stampe: { [S: string]: number } = {};

        Data?.RisAPI.Dati.map(ECD => {
            const S = ECD.ID_BinderCompagnia.toString(); // + "-" + ECD.PercRitenuta;
            if (Stampe[S] === null) {
                Stampe[S] = 1;
            }
            else {
                Stampe[S] += 1;
            }
        });
        Glob.Log(Glob.LogCat.Stampa, false, [URL, Stampe]);
        for (const S in Stampe) {
            let NP = 1;
            if (Stampe[S] > 11) {
                NP = ((Stampe[S] - 18) / 30) + 1; //Numero righe della pagina iniziale nel caso in cui il riepilogo sia nell'ultima pagina (oltre la prima)
            }
            window.open(URL + "EstrattoContoPag" + NP + "&Filtro=" + S, "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
            Glob.Sleep(500);
        }
    }

    return (
        <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-handshake"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("EstrattoContoDettagli")}</h3>
                    </div>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("EstrattoConto")}</label>
                        <div className="col-lg-1 form-control-plaintext">
                            <input type="text" className="form-control" value={Data?.Extra.ID_EstrattoConto || ""} name="Data.Extra.ID_EstrattoConto" disabled />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Stato")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="form-control">
                                {Trad.Trad(Data?.RisAPI.Tipi["EstrattoContoStato"][Data?.Extra.ID_TipoEstrattoContoStato].Valore ?? "")}
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("DataDa")}</label>
                        <div className="col-lg-2 form-control-plaintext">
                            <div className="form-control">
                                <CampoData ValoreInArrivo={false}
                                    Name="DataDa"
                                    Id="DataDa"
                                    Disabilitato
                                    Valore={Data?.Extra.DataDa}
                                    OnChange={() => { }} />
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("DataA")}</label>
                        <div className="col-lg-2 form-control-plaintext">
                            <div className="form-control">
                                <CampoData ValoreInArrivo={false}
                                    Name="DataA"
                                    Id="DataA"
                                    Disabilitato
                                    Valore={Data?.Extra.DataA}
                                    OnChange={() => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Da")}</label>
                        <div className="col-lg-5 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagDa" ID_Chiave={Data?.Extra.ID_AnagDa} OnAggiorna={() => { }} TradValori Disabilitato />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("A")}</label>
                        <div className="col-lg-5 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagA" ID_Chiave={Data?.Extra.ID_AnagA} OnAggiorna={() => { }} TradValori Disabilitato />
                        </div>
                    </div>
                </div>
            </form>
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref={refTabella}>
                    <thead>
                        <tr className="sfondoTab">
                            <th scope="row" className="TextLeft">{Trad.Trad("Date")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Quietanza")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Stato")}</th>
                            <th scope="row" className="TextLeft">{Trad.Trad("Polizza")}/{Trad.Trad("Contraente")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("TipoProdotto")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("PremioLordoDare")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("ProvvigioniDare")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("PremioLordoAvere")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("ProvvigioniAvere")}</th>
                            <th scope="row" className="TextCenter">{Trad.Trad("Extra")}</th>
                            <th data-field="edit" className="TextCenter">{Trad.Trad("Azioni")}</th>
                        </tr>
                    </thead>
                    {RiempiTabella()}
                </table>
            </div>
            <div className="kt-portlet__foot kt-portlet__foot--fit">
                <div className="kt-form login-form__actions kt-form login-form__actions--left">
                    <div className="col kt-form__actions kt-form__actions--left row">
                        <div className="col-lg-3 kt--align-left">
                            {Trad.Trad("TotalePremioLordoDare")}<br />
                            {Trad.Trad("TotalePremioLordoAvere")}<br />
                            <b>{Trad.Trad("TotalePremioLordo")}</b><br />
                            {Trad.Trad("TotaleProvvigioniDare")}<br />
                            {Trad.Trad("TotaleProvvigioniAvere")}<br />
                            <b>{Trad.Trad("TotaleProvvigioni")}</b><br />
                            {memoTotalePercRitenuta !== undefined &&
                                <><b>{Trad.TradParam("TotaleRitenuta{1-P}", [memoTotalePercRitenuta])}</b><br /></>
                            }
                            <b>{Trad.Trad("TotaleRimessa")}</b><br />
                            {memoTotalePremioLordoIncassi !== 0 &&
                                <>{Trad.Trad("TotalePremioLordoIncassi")}<br /></>
                            }
                            {memoTotaleDescrExtra !== undefined &&
                                <>{Trad.Trad("" + memoTotaleDescrExtra)}<br /></>
                            }
                            {memoTotaleIncassi !== 0 &&
                                <><b>{Trad.Trad("TotaleIncassi")}</b><br /></>
                            }
                            <b>{Trad.Trad("TotaleSaldo")}</b><br />
                        </div>
                        <div className="col-lg-1 TextRight">
                            {Trad.TradParam("{1-I}", [memoTotalePremioLordoDare])}<br />
                            {Trad.TradParam("{1-I}", [memoTotalePremioLordoAvere])}<br />
                            <b>{Trad.TradParam("{1-I}", [memoTotalePremioLordoDare + memoTotalePremioLordoAvere])}</b><br />
                            {Trad.TradParam("{1-I}", [memoTotaleProvvigioniDare])}<br />
                            {Trad.TradParam("{1-I}", [memoTotaleProvvigioniAvere])}<br />
                            <b>{Trad.TradParam("{1-I}", [memoTotaleProvvigioniDare + memoTotaleProvvigioniAvere])}</b><br />
                            {memoTotalePercRitenuta !== undefined &&
                                <><b>{Trad.TradParam("{1-I}", [memoTotaleRitenuta])}</b><br /></>
                            }
                            <b>{Trad.TradParam("{1-I}", [(memoTotalePremioLordoDare + memoTotalePremioLordoAvere) - (memoTotaleProvvigioniDare + memoTotaleProvvigioniAvere) + memoTotaleRitenuta])}</b><br />
                            {memoTotalePremioLordoIncassi !== 0 &&
                                <>{Trad.TradParam("{1-I}", [memoTotalePremioLordoIncassi])}<br /></>
                            }
                            {memoTotaleDescrExtra !== undefined &&
                                <>{Trad.TradParam("{1-I}", [memoTotaleExtra])}<br /></>
                            }
                            {memoTotaleIncassi !== 0 &&
                                <><b>{Trad.TradParam("{1-I}", [memoTotaleIncassi])}</b><br /></>
                            }
                            <b>{Trad.TradParam("{1-I}", [memoTotaleSaldo])}</b><br />
                        </div>
                    </div>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <div className="col-lg-2 form-control-plaintext">
                            <label className="col-form-label">{Trad.Trad("PagamentoData")}</label>
                            <div className="form-control">
                                <CampoData ValoreInArrivo={false}
                                    Name="PagamentoData"
                                    Id="PagamentoData"
                                    Valore={EstrattoConto.PagamentoData}
                                    Disabilitato={EstrattoConto.ID_TipoEstrattoContoStato === Glob.Tipi_ECS_Chiuso}
                                    OnChange={(e, v) => setEstrattoConto({ Type: "OnChangeFromHybrid", NameEvent: e, Value: v })}
                                />
                            </div>
                            <label className="col-form-label">{Trad.Trad("PagamentoImporto")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <CampoNumero
                                    CSS="form-control kt-input"
                                    Precisione={2}
                                    Name="PagamentoImporto"
                                    Id="PagamentoImporto"
                                    Valore={EstrattoConto.PagamentoImporto}
                                    Disabilitato={EstrattoConto.ID_TipoEstrattoContoStato === Glob.Tipi_ECS_Chiuso}
                                    OnChange={(e, v) => setEstrattoConto({ Type: "OnChangeFromHybrid", NameEvent: Object.assign({}, e), Value: v })}
                                />
                            </div>
                            <label className="col-form-label">{Trad.Trad("Differenza")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <CampoNumero
                                    CSS="form-control kt-input"
                                    Precisione={2}
                                    Name="PagamentoDifferenza"
                                    Id="PagamentoDifferenza"
                                    Valore={(EstrattoConto.PagamentoImporto ?? 0) - memoTotaleSaldo}
                                    Disabilitato
                                    OnChange={(e, v) => { }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-5 form-control-plaintext">
                            <label className="col-form-label">{Trad.Trad("Note")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <textarea rows={8} cols={70} id="Note" value={EstrattoConto.Note ?? ""} onChange={(e) => setEstrattoConto({ Type: "OnChangeFromForm", Target: e.currentTarget })} disabled={EstrattoConto.ID_TipoEstrattoContoStato === Glob.Tipi_ECS_Chiuso} />
                            </div>
                        </div>
                        <div className="col-lg-2 form-control-plaintext">
                            <BottoneAPI
                                Default={false}
                                Testo={Trad.Trad("ChiudiEstrattoConto")}
                                ParamCorpo={{ Dato: EstrattoConto } as Dati.CIngrAPI<Dati.CDatiEstrattoConto>}
                                URL="/api/EstrattoConto/Chiudi"
                                Metodo="POST"
                                Attivo={ChiudiEstrattoContoAttivo()}
                                OnClick={(s, d) => OnClickBottoneAPI(s, d)}
                                OnErrore={(s, e) => OnErroreBottoneAPI(s, e)}
                                DataDismiss="modal"
                            />
                        </div>
                        <div className="col-lg-1 form-control-plaintext">
                            <Bottone
                                Default={false}
                                Testo={Trad.Trad("Stampa")}
                                OnClick={(s) => Stampa()}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div >
    );
}



// WEBPACK FOOTER //
// ./src/form/EstrattoContoDettagli.tsx